import { PayloadAction } from '../../../store.model';
import { createFocusTags } from '../function/create-behaviour-tags.function';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { EditNotesFocus } from './edit-notes-focus.action';

export function editNotesFocusReducer(
    state: TranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TD__EDIT_NOTES_FOCUS,
        EditNotesFocus
    >,
): TranscriptDialogState {
    try {
        const cmtNotesFocus = createFocusTags(
            [action.payload.focus],
            state.behaviours,
            state.subBehaviours,
        )?.[0];

        return {
            ...state,
            cmtNotesFocus,
        };
    } catch (err) {
        console.log(err);
    }
}
